type FunctionItem = { id: string; isAssigned: boolean };
type MenuItem = {
  id: string;
  title: string;
  route: string;
  sortOrder: number;
  functions?: FunctionItem[];
  children?: MenuItem[];
};

export function collectAssignedFunctionIds(items: MenuItem[]) {
  const out = new Set<string>();

  const walk = (nodes: MenuItem[]) => {
    for (const node of nodes) {
      node.functions?.forEach((fn) => {
        if (fn.isAssigned) out.add(fn.id);
      });
      if (node.children?.length) walk(node.children);
    }
  };

  walk(items);
  return out;
}

export function areSetsEqual(a: Set<string>, b: Set<string>) {
  if (a.size !== b.size) return false;
  for (const v of a) if (!b.has(v)) return false;
  return true;
}
